module.exports = __webpack_public_path__ + "static/img/zh_CN.4470254e.png";